export default __webpack_public_path__ + "static/media/uranus.cd71c999.svg";